// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EventSettingsModal.css */
.mediasfu-event-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.mediasfu-event-modal .modal-title {
  font-size: 18px;
  font-weight: bold;
  color: black;
}

.mediasfu-event-modal .close-btn {
  padding: 5px;
}

.mediasfu-event-modal .modal-body {
  flex: 1;
}

.mediasfu-event-modal .form-group {
  margin-bottom: 20px;
}

.mediasfu-event-modal .label {
  font-size: 14px;
  color: black;
  margin-bottom: 5px;
  font-weight: bold;
  padding-right: 10px;
}

.mediasfu-event-modal .hr {
  height: 1px;
  background-color: black;
  margin-top: 5px;
  margin-bottom: 5px;
}

.mediasfu-event-modal .sep {
  height: 1px;
  background-color: white;
  margin-top: 0;
  margin-bottom: 0;
}

.mediasfu-event-modal .modal-footer {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.mediasfu-event-modal .btn-apply-settings {
  padding: 5px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  background-color: black;
  color: white;
  font-size: 14px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/eventSettingsComponents/EventSettingsModal.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* EventSettingsModal.css */\r\n.mediasfu-event-modal .modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.mediasfu-event-modal .modal-title {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  color: black;\r\n}\r\n\r\n.mediasfu-event-modal .close-btn {\r\n  padding: 5px;\r\n}\r\n\r\n.mediasfu-event-modal .modal-body {\r\n  flex: 1;\r\n}\r\n\r\n.mediasfu-event-modal .form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.mediasfu-event-modal .label {\r\n  font-size: 14px;\r\n  color: black;\r\n  margin-bottom: 5px;\r\n  font-weight: bold;\r\n  padding-right: 10px;\r\n}\r\n\r\n.mediasfu-event-modal .hr {\r\n  height: 1px;\r\n  background-color: black;\r\n  margin-top: 5px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.mediasfu-event-modal .sep {\r\n  height: 1px;\r\n  background-color: white;\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.mediasfu-event-modal .modal-footer {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.mediasfu-event-modal .btn-apply-settings {\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: black;\r\n  color: white;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
